import React, { useEffect } from "react";
import { toNumber } from "service/service";
import useQuery from "utils/useQuery";
import SignInDetail from "./components/SignInDetail";
import { currentSignInAtom } from "../Store";
import { useSetAtom } from "jotai";

export default function SignIn() {
    const { id, status } = useQuery<{ id: string; status: string }>();
    const signInId = toNumber(id);

    const setCurrentId = useSetAtom(currentSignInAtom);

    useEffect(() => {
        setCurrentId(signInId);
    }, [signInId]);

    return <SignInDetail key={`${signInId}-${status}`} signInId={signInId} />;
}
